module.exports = [{
      plugin: require('/Users/itz/Documents/CodePlaygound/votetandem-site/votetandem-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
